import styles from './MobileMenu.module.scss';
import SearchMenu from '@components/components/Navigation/components/SearchMenu/SearchMenu';
import iconWeTheme from '@components/images/logo/logo-we-theme-white.svg';
import iconPositions from '@components/images/logo/logo-positions-white.png';
import React, { useRef } from 'react';
import { FontAwesomeProIcon, Link } from '@wienenergiegithub/ui-next';
import { Button as BaseButton } from '@ariakit/react';
import classNames from 'classnames';

const MobileMenu = ({
  isSearchOpen,
  setIsSearchOpen,
  showOverlay,
  setShowOverlay,
  isReduced,
  logoLink,
  logoLinkDescription,
  logoType,
  serviceUrl,
}) => {
  const searchBarRef = useRef(null);

  // close overlay if open before displaying search bar
  const handleSearchButtonClick = () => {
    setShowOverlay(false);
    setIsSearchOpen(true);
  };

  const closeSearch = () => {
    setIsSearchOpen(false);
  };

  return (
    <>
      {!isSearchOpen && (
        <ul
          className={classNames(styles.menuList, {
            [styles.isSearchOpen]: isSearchOpen,
          })}
        >
          <li className={styles.menuListItem}>
            <Link
              aria-label={logoLinkDescription}
              className={styles.menuListItemLink}
              to={logoLink}
            >
              <img
                alt=""
                className={styles.logo}
                role="presentation"
                src={logoType === 'positions' ? iconPositions : iconWeTheme}
              />
            </Link>
          </li>
          {!isReduced && (
            <>
              {serviceUrl && (
                <li className={styles.menuListItem}>
                  <Link
                    aria-label="Login"
                    className={styles.menuListItemLink}
                    to={serviceUrl}
                  >
                    <FontAwesomeProIcon
                      className={styles.icon}
                      icon="user"
                      role="presentation"
                      type="solid"
                    />
                  </Link>
                </li>
              )}
              <li className={styles.menuListItem}>
                <BaseButton
                  aria-label="Suchfeld öffnen"
                  className={styles.menuListItemButton}
                  onClick={handleSearchButtonClick}
                >
                  <FontAwesomeProIcon
                    className={styles.icon}
                    icon="search"
                    type="solid"
                  />
                </BaseButton>
              </li>
            </>
          )}
          <li className={styles.menuListItem}>
            <BaseButton
              aria-label={
                !showOverlay ? 'Menüleiste öffnen' : 'Menüleiste schließen'
              }
              className={styles.menuListItemButton}
              onClick={() => setShowOverlay(prev => !prev)}
            >
              <span
                className={classNames(styles.inner, {
                  [styles.isOpen]: showOverlay,
                })}
              >
                {/*  four lines required for the burger menu animation */}
                {Array.from({ length: 4 }, (_, index) => index).map(el => (
                  <span
                    className={classNames(styles.line, {
                      [styles.isOpen]: showOverlay,
                    })}
                    key={el}
                    role="presentation"
                  />
                ))}
              </span>
            </BaseButton>
          </li>
        </ul>
      )}
      {isSearchOpen && (
        <div
          aria-hidden={!isSearchOpen}
          className={classNames(styles.searchBarContainer, {
            [styles.isSearchOpen]: isSearchOpen,
          })}
        >
          <SearchMenu
            handleSearchOpen={setIsSearchOpen}
            isSearchOpen={isSearchOpen}
            ref={searchBarRef}
          />
          <BaseButton
            aria-label="Suchfeld ausblenden"
            className={styles.menuListItemButton}
            onClick={closeSearch}
          >
            <FontAwesomeProIcon
              className={classNames(styles.icon, styles.closeSearch)}
              icon="times"
              role="presentation"
            />
          </BaseButton>
        </div>
      )}
    </>
  );
};

export default MobileMenu;
